{
  "primary": {
    "primary-50": "#f0fbff",
    "primary-100": "#e4f6ff",
    "primary-150": "#d7f2fe",
    "primary-200": "#cbedfd",
    "primary-250": "#bceafe",
    "primary-300": "#ade7ff",
    "primary-350": "#9de3ff",
    "primary-400": "#8ce0ff",
    "primary-450": "#5ac9ff",
    "primary-500": "#26aeff",
    "primary-550": "#008fff",
    "primary-600": "#146cfd",
    "primary-650": "#0c5ad4",
    "primary-700": "#0548ad",
    "primary-750": "#023688",
    "primary-800": "#002664",
    "primary-850": "#001a4d",
    "primary-900": "#001037",
    "primary-950": "#000622"
  },
  "accent": {
    "accent-50": "#fff8f9",
    "accent-100": "#fff2f4",
    "accent-150": "#ffecef",
    "accent-200": "#ffe6ea",
    "accent-250": "#ffdbe0",
    "accent-300": "#ffcfd6",
    "accent-350": "#ffc4cc",
    "accent-400": "#ffb8c1",
    "accent-450": "#f897a2",
    "accent-500": "#ef7581",
    "accent-550": "#e44f5f",
    "accent-600": "#d7153a",
    "accent-650": "#b90e32",
    "accent-700": "#9b072a",
    "accent-750": "#7e0322",
    "accent-800": "#630019",
    "accent-850": "#4c0010",
    "accent-900": "#360008",
    "accent-950": "#210003"
  },
  "grey": {
    "grey-50": "#fafafa",
    "grey-100": "#f5f5f5",
    "grey-150": "#f0f0f0",
    "grey-200": "#ebebeb",
    "grey-250": "#e3e5e6",
    "grey-300": "#dcdfe0",
    "grey-350": "#d4d9db",
    "grey-400": "#cdd3d6",
    "grey-450": "#aab0b4",
    "grey-500": "#888f92",
    "grey-550": "#686f72",
    "grey-600": "#495054",
    "grey-650": "#3f4549",
    "grey-700": "#353b3f",
    "grey-750": "#2b3135",
    "grey-800": "#22272b",
    "grey-850": "#181c1f",
    "grey-900": "#0e1113",
    "grey-950": "#050709"
  }
}
